import jquery from 'jquery';
import 'jquery.transit';
import 'jquery-easing';
import 'es6-promise/auto';

window.$ = jquery;
window.jQuery = jquery;

import owd from 'owd/owd';
import 'app/components/img-load';
import 'app/components/form';
import 'app/components/slider';
import 'app/components/scroll-top';
import 'app/components/menu-toggle';
import 'app/components/nav-toggle';
import 'app/components/inview';
import 'app/components/menu-scroll';
import 'app/components/burger-scroll';
import 'app/components/show-burger';
import 'app/components/filter';
// import 'app/components/filter-categories';
import 'app/components/accordion';
import 'app/components/player-info';
import 'app/components/cookies-info';
import 'app/components/page-in';
import 'app/components/fullscreen-player';
// import 'app/components/hover';
import 'app/components/video';
import 'app/components/fs-player';
import 'app/components/video-autoplay-fp';
import 'app/components/video-autoplay-case';

// import 'app/components/video-plug';
import 'app/components/header';
import 'app/components/masonry-fun';
import 'app/components/long-list';
import 'app/components/works';
import 'app/components/src';





// import 'app/components/fullpage-section';
// import 'app/components/fullpage-container';

import DefaultResolver from 'app/ajax/default-resolver';
import CategoriesResolver from 'app/ajax/categories-resolver';

import Ajax from 'owd/module/ajax';
import BrowserCheck from 'owd/module/browser-check';
import Handlebars from 'owd/module/handlebars';
// import FullPage from 'owd/module/fullpage';
// import ScrollbarPlaceholder from 'owd/module/scrollbar-placeholder';

const app = new owd.App();

// app.use('scrollbarPlaceholder', ScrollbarPlaceholder);
// app.use('fullpage', FullPage);
app.use('ajax', Ajax)
    .registerDefaultResolver(DefaultResolver)
    .registerResolver('categories', CategoriesResolver);

app.use('browser-check', BrowserCheck);
app.use('handlebars', Handlebars);
app.run();
